<span class="text-nowrap">
  <core-money-amount [amount]="amount"></core-money-amount>
  <core-money-currency [tooltipPlacement]="tooltipPlacement" [currencyDescription]="currencyDescription" [currency]="currency"></core-money-currency>
</span>